import { InputAdornment, TextField } from '@mui/material';
import { getIcons } from '_helpers';
import React, { useState, useEffect } from 'react';

const SearchInput = ({ data, onFilteredData }) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Filtre les données en fonction du terme de recherche
    useEffect(() => {
        const filteredData = data.filter(item =>
            Object.values(item).some(field =>
                field != null &&
                field.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        onFilteredData(filteredData);
    }, [searchTerm, data, onFilteredData]);

    // Fonction appelée lorsqu'il y a un changement dans le champ de recherche
    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Fonction appelée pour effacer le contenu du champ de recherche
    const handleClear = () => {
        setSearchTerm('');
    };

    return (
        <TextField
            variant="outlined"
            type="text"
            placeholder="Rechercher dans le tableau..."
            value={searchTerm}
            onChange={handleChange}
            sx={{ width: '300px', 
                '& .MuiOutlinedInput-root': {
                    height: '40px',
                    '& input': {
                        padding: '10px',
                    },
                }, 
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start" sx={{ opacity: 0.5 }}>
                        <img src={getIcons("searchOutlinedGrey")} alt='icone loupe' />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        {searchTerm && (
                        <button edge="end" onClick={handleClear}>
                            <img src={getIcons('clearOutlinedBlack')} alt='icone clear' />
                        </button>
                        )}
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchInput;
